var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7502 21.5041C17.7502 25.0961 20.8843 28.0081 24.7502 28.0081C28.6162 28.0081 31.7502 25.0961 31.7502 21.5041C31.7502 17.912 28.6162 15 24.7502 15C20.8843 15 17.7502 17.912 17.7502 21.5041ZM35.2501 28.0081C35.2501 30.7022 37.6006 32.8861 40.5001 32.8861C43.3996 32.8861 45.7501 30.7022 45.7501 28.0081C45.7501 25.314 43.3996 23.13 40.5001 23.13C37.6006 23.13 35.2501 25.314 35.2501 28.0081Z",
    fill: "#2335C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7208 31.2601C16.4583 31.2601 9.67945 35.2057 9.00114 42.9661C8.96419 43.3888 9.83425 44.2682 10.2731 44.2682H39.1817C40.4963 44.2682 40.5168 43.2853 40.4963 42.9674C39.9835 34.9889 33.0996 31.2601 24.7208 31.2601ZM50.0482 44.268H43.2998C43.2998 40.6079 41.9982 37.2303 39.8017 34.5129C45.7634 34.5732 50.6313 37.3737 50.9976 43.2924C51.0124 43.5308 50.9976 44.268 50.0482 44.268Z",
    fill: "#2335C2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 0.619873,
    y: 0.620041,
    width: 60,
    height: 60,
    rx: 4.96,
    fill: "#263BD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.631a31e1950ed53e161048fc4524d9d8.svg";
export { ForwardRef as ReactComponent };